import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { setOwner } from '../../../actions/SetOwnerAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userCanManageAnyCollection } from './IEntityActionHelpers';

export const SetCollectionOwnerEntityAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: () => {
    return FeatureFlags.collectionsEnabled;
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[], state: AppState) => {
    return !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state) && userCanManageAnyCollection(state, targetItems);
  },
  createReduxAction: (targetItems: ICollectionInfo[]) => setOwner(targetItems)
};
